/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useState } from 'react';
import { Form } from 'formik';
import { useSelector } from 'react-redux';
import { getCurrenLang } from '../../redux/selector';
import {
  InputToolkit,
  Checkbox,
  InputPasswordFloatLabel,
  InputFloatLabel,
} from '../../common/Input';
import { Button } from '../../common/Button/Button';
import { ShowErrorNotification } from './ErrorMessage';
import styles from './styles.module.css';
import { SignUpAccountCreatedProps, SignUpAccountProps, SignUpAccountVerifiedProps } from './types';
import { CustomLink } from '../../common';

export const SignUpAccount = ({
  touched,
  errors,
  handleChange,
  values,
  handleSubmit,
  isSubmitting,
}: SignUpAccountProps): ReactElement => {
  const t: any = useSelector<any>((state) => getCurrenLang(state));
  const email = t && t.auth.email;
  const continue_btn = t && t.common.continue;

  return (
    <Form onSubmit={handleSubmit} className={styles.form_wrapper}>
      <InputFloatLabel
        inputId="signUpEmail"
        isTouched={touched.email}
        hasErrors={errors.email}
        inputValue={values.email}
        onChangeMethod={handleChange}
        placeholder={email}
        inputName="email"
        inputType="email"
        disabled
      />
      <div className={styles.content}>
        <Button
          buttonType="submit"
          buttonName={continue_btn}
          disabledButton={isSubmitting}
          buttonClass={styles.btn__submit}
        />
      </div>
    </Form>
  );
};

export const SignUpAccountVerified = ({
  touched,
  errors,
  values,
  handleSubmit,
  isSubmitting,
  resendMethod,
  resendPending,
  error,
  setFieldValue,
  resendPinCodeMessage,
}: SignUpAccountVerifiedProps): ReactElement => {
  const t: any = useSelector<any>((state) => getCurrenLang(state));
  const continue_btn = t && t.common.continue;
  const pin_code = t && t.auth.pin_code;
  const button_resend = t && t.common.button_resend;

  const [err, setErr] = useState('');

  useEffect(() => {
    setErr(error);
  }, [error]);

  const changeHandler = (e: any): void => {
    if (err) {
      setErr('');
    }
    setFieldValue('code', e.target.value);
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <InputPasswordFloatLabel
          inputId="loginPassword"
          inputName="password"
          hasErrors={errors.code}
          inputValue={values.code}
          isTouched={touched.code}
          onChangeMethod={(e: any): void => changeHandler(e)}
          placeholder={pin_code}
          disabled={false}
        />
        {err && !touched.code && (
          <div className={styles.form_wrapper}>
            {err && <div className={styles.errorMessages}>{err}</div>}
          </div>
        )}
        {resendPending && (
          <div className={styles.form_wrapper}>
            <div className={styles.errorMessages}>{resendPinCodeMessage}</div>
          </div>
        )}
        <div className={styles.flex_container}>
          <Button
            buttonType="submit"
            buttonName={continue_btn}
            disabledButton={isSubmitting}
            buttonClass={styles.btn__submit}
          />
          <CustomLink
            buttonMethod={resendMethod}
            buttonName={button_resend}
            disabledButton={resendPending}
          />
          {/* <Button
            buttonType="button"
            buttonName={button_resend}
            buttonMethod={resendMethod}
            disabledButton={resendPending}
          /> */}
        </div>
      </Form>
    </>
  );
};
export const SignUpAccountCreated = ({
  errorMessage,
  hasErrors,
  inputValue,
  isTouched,
  onChangeMethod,
}: SignUpAccountCreatedProps): ReactElement => {
  const t: any = useSelector<any>((state) => getCurrenLang(state));
  const create_password = t?.auth.create_password;
  const repeat_password = t?.auth.repeat_password;
  const acceptTerms_one = t?.auth.acceptTerms_one;
  const acceptTerms_terms_of_service = t?.auth.acceptTerms_terms_of_service;
  const acceptTerms_three = t?.auth.acceptTerms_three;
  const acceptTerms_privacy_statement = t?.auth.acceptTerms_privacy_statement;
  const create_account = t?.common.create_account;
  const terms_content = t?.terms_of_service.content;
  const privacy_content = t?.privacy_statement.content;

  return (
    <div className={styles.form_folder}>
      <InputToolkit
        inputId="CreatePassword"
        placeholder={create_password}
        inputName="password"
        hasErrors={hasErrors.password}
        inputValue={inputValue.password}
        isTouched={isTouched.password}
        onChecngeMethod={onChangeMethod}
      />
      <InputPasswordFloatLabel
        inputId="repeatpassword"
        placeholder={repeat_password}
        inputName="repeatpassword"
        hasErrors={hasErrors.repeatpassword}
        inputValue={inputValue.repeatpassword}
        isTouched={isTouched.repeatpassword}
        onChangeMethod={onChangeMethod}
      />
      <div className={styles.confirm}>
        <Checkbox
          hasErrors=""
          inputValue={inputValue.acceptTerms}
          isTouched={isTouched.acceptTerms}
          onChengeMehtod={onChangeMethod}
          inputName="acceptTerms"
        />
        <p className={styles.confirm_checkbox}>
          {acceptTerms_one}
          <a
            href={terms_content}
            className={styles.section_highlighted}
            target="_blank"
            rel="noopener noreferrer"
          >
            {acceptTerms_terms_of_service}
          </a>
          {acceptTerms_three}
          <a
            href={privacy_content}
            className={styles.section_highlighted}
            target="_blank"
            rel="noopener noreferrer"
          >
            {acceptTerms_privacy_statement}
          </a>
          .
        </p>
      </div>
      {isTouched.acceptTerms && hasErrors.acceptTerms && (
        <div className={styles.errorMessages}>
          <ShowErrorNotification errorMessage={hasErrors.acceptTerms} />
        </div>
      )}
      {errorMessage && (
        <div className={styles.errorMessages}>
          <ShowErrorNotification errorMessage={errorMessage} />
        </div>
      )}

      <div className={styles.content}>
        <Button buttonType="submit" buttonName={create_account} buttonClass={styles.btn__submit} />
      </div>
    </div>
  );
};
